

export const getProjects = 'project/getProjects';
export const changeProjects = 'project/changeProjects';
